import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { KeycloakService } from '@inoventoryapps/keycloak-angular';
import {  UserDetails } from '../models/keycloak.model';
import { LocalStorageService } from '../services/local-storage.service';
import { GlobalService } from '../services/global.service';

interface RoleConfigEntry {
  ogName: any;
  userType: any;
  verticle: any;
  name?: any;
}

@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrl: './toolbar.component.scss'
})
export class ToolbarComponent implements OnInit {
    public showPopOver = false;
    public userDetails: UserDetails | any = {} as UserDetails;
    rolesGroup: any[] = [];
    public permissionMappedRaw: any[] = [];
    private readonly userImageStorageKey = 'userImage';
    private readonly defaultUserImage = '../../assets/img/user-icon.png';
    userImg: string = this.defaultUserImage;



    // currentUserRole: any = ''

    constructor(public eRef: ElementRef, public keycloakService: KeycloakService, public localStorageService: LocalStorageService, public gs: GlobalService) { }

    ngOnInit(): void {
        (async () => {
            this.userDetails = this.gs.getUserDetails();
            this.loadUserProfileImage();
            this.loadSubRolesFromPermissionAPI();

            // if (this.userDetails?.sub) {

            // } else {
            // }
            //this.loadSubRolesFromPermissionAPI();
            // let roles: any = []
            // let generalInfo: any = {}
            // let requ: any = []
            // for (let key in userInfo.resource_access) {
            //     let t: any = ['S', 'B', 'N', 'D']
            //     let s = key.split('-')
            //     requ = []
            //     if (key.includes('-') && t.includes(key.split('-')[0])) {
            //         for (let i = 0; i < userInfo.resource_access[key].roles.length; i++) {
            //             let rolestring: any = userInfo.resource_access[key].roles[i].split('-')
            //             if (rolestring[1] && rolestring[1] == 'manager' && rolestring[2]) {
            //                 requ.push(userInfo.resource_access[key].roles[i])
            //             }
            //         }
            //         roles = [...roles, ...requ]
            //         if (s[0].toLowerCase() === 'b') {
            //             generalInfo['blockId'] = key
            //         } else if (s[0].toLowerCase() === 's') {
            //             generalInfo['stateId'] = key
            //         } else if (s[0].toLowerCase() === 'd') {
            //             generalInfo['districtId'] = key
            //         } else if (s[0].toLowerCase() === 'n') {
            //         }
            //     }
            // }

            // if (roles.length) {
            //     this.userDetails = {
            //         role: roles,
            //         // blockId: generalInfo?.blockId || '',
            //         // districtId: generalInfo?.districtId || '',
            //         // stateId: generalInfo?.stateId || '',
            //         mobileNumber: +userInfo.phone_number,
            //         tenantId: userInfo?.tenant_id,
            //         userName: userInfo.name,
            //     };


            //     // let str: any
            //     // let r: any
            //     // for (let i = 0; i < this.userDetails.role.length; i++) {
            //     //     str = this.userDetails.role[i].split('-')
            //     //     if (str[1] && str[1] == 'manager' && str[2]) {
            //     //         r = this.userDetails.role[i]
            //     //     }
            //     // }
            //     let t: any = this.gs.roleConfig[this.userDetails.role[0]]
            //     if (!this.localStorageService.get('role')) {
            //         this.localStorageService.set<UserDetails>('role', t.userType);
            //         this.localStorageService.set<UserDetails>('fullUserRoleVerticle', t.ogName);
            //         this.localStorageService.set<UserDetails>('verticle', t.verticle);
            //     }
            //     this.userDetails['activeRole'] = this.localStorageService.get('role')
            //     this.userDetails['activeRoleVerticle'] = this.localStorageService.get('verticle')
            //     this.userDetails['fullUserRoleVerticle'] = this.localStorageService.get('fullUserRoleVerticle')
            //     generalInfo = this.gs.getGeoLocation(generalInfo, this.userDetails['activeRole'])
            //     this.userDetails['blockId'] = generalInfo?.blockId || ''
            //     this.userDetails['districtId'] = generalInfo?.districtId || ''
            //     this.userDetails['stateId'] = generalInfo?.stateId || ''
            //     this.localStorageService.set<UserDetails>('userDetails', this.userDetails);
            // } else {
            //     // this.keycloakService.logout();
            //     // localStorage.clear();
            //     // sessionStorage.clear();
            // }
        })();
    }

    private loadUserProfileImage(): void {
        const cachedImage = this.localStorageService.get<string>(this.userImageStorageKey);
        if (cachedImage) {
            this.userImg = this.toImageSource(cachedImage);
        }

        this.gs.getUserProfileImage().subscribe({
            next: (image: string) => {
                if (!image) {
                    return;
                }
                this.userImg = this.toImageSource(image);
                this.localStorageService.set(this.userImageStorageKey, image);
            },
            error: () => {
                this.userImg = this.userImg || this.defaultUserImage;
            }
        });
    }

    private toImageSource(image: string): string {
        const normalizedImage = image.trim();

        if (!normalizedImage) {
            return this.defaultUserImage;
        }

        if (normalizedImage.startsWith('data:') || normalizedImage.startsWith('http')) {
            return normalizedImage;
        }

        return `data:image/png;base64,${normalizedImage}`;
    }

    togglePopOver(event: Event) {
        event.stopPropagation();
        this.showPopOver = !this.showPopOver;
    }

  @HostListener('document:click', ['$event'])
    public closePopOver(event: Event) {
        const userProfileElement = this.eRef.nativeElement.querySelector('.user-profile');

        if (!userProfileElement.contains(event.target)) {
            this.showPopOver = false;
        }
    }

  activeRoleData: string = '';
  changeRole(role: string): void {
      if (!role || !this.isKnownSelectableRole(role)) {
          return;
      }

      // 👉 Extract role name + geoId safely
      const match = role.match(/^(.+?)\((.+?)\)$/);
      const roleName = (match ? match[1] : role)?.trim();
      const geoId = match ? match[2]?.trim() : '';

      // 👉 Find role config (SAFE MATCH)
      const found = this.findRoleConfig(roleName);

      if (!found || typeof found !== 'object' || !('userType' in found)) {
          return;
      }

      const roleMeta = found as RoleConfigEntry;

      const geoInput: any = {};

      if (roleMeta.userType === 'block' && geoId) {
          geoInput.blockId = geoId.startsWith('B-') ? geoId : `B-${geoId}`;
      }
      else if (roleMeta.userType === 'district' && geoId) {
          geoInput.districtId = geoId.startsWith('D-') ? geoId : `D-${geoId}`;
      }
      else if (roleMeta.userType === 'state' && geoId) {
          geoInput.stateId = geoId.startsWith('S-') ? geoId : `S-${geoId}`;
      }

      let normalizedGeo: any = {};

      try {
          normalizedGeo = this.gs.getGeoLocation(geoInput, roleMeta.userType) || {};
      } catch (error) {
          return;
      }

      if (!this.isValidGeoForRole(roleMeta.userType, normalizedGeo)) {
          return;
      }

      // 👉 Update user details safely
      // ✅ clear old geo first, then assign all geo from normalizedGeo
      this.userDetails = {
          ...this.userDetails,

          activeRole: roleMeta.userType,
          activeRoleVerticle: roleMeta.verticle,
          fullUserRoleVerticle: roleMeta.ogName,

          // ✅ assign full geo hierarchy from normalizedGeo
          blockId: normalizedGeo?.blockId || '',
          districtId: normalizedGeo?.districtId || '',
          stateId: normalizedGeo?.stateId || ''
      };

      this.userDetails.selectedRoleWithGeo = role;
      this.gs.setUserDetails(this.userDetails);

      const nextUrl = this.gs.buildUrlWithSelectedRole(role);
      if (nextUrl) {
          window.location.assign(nextUrl);
      }
  }

  private isKnownSelectableRole(role: string): boolean {
      return (this.rolesGroup || []).includes(role) || (this.userDetails?.role || []).includes(role);
  }

  private findRoleConfig(roleName: string): RoleConfigEntry | undefined {
      const normalizedRoleName = this.normalizeRoleName(roleName);

      return Object.entries(this.gs.roleConfig || {})
          .map(([key, config]: [string, any]) => ({ key, config }))
          .find(({ key, config }) =>
              this.normalizeRoleName(key) === normalizedRoleName ||
              this.normalizeRoleName(config?.ogName) === normalizedRoleName ||
              this.normalizeRoleName(config?.name) === normalizedRoleName
          )?.config as RoleConfigEntry | undefined;
  }

  private normalizeRoleName(roleName: unknown): string {
      return String(roleName || '')
          .trim()
          .toLowerCase()
          .replace(/[\s_]+/g, '-');
  }

  private isValidGeoForRole(userType: string, geo: any): boolean {
      if (userType === 'block') {
          return !!geo?.blockId && !!geo?.districtId && !!geo?.stateId;
      }

      if (userType === 'district') {
          return !!geo?.districtId && !!geo?.stateId && !geo?.blockId;
      }

      if (userType === 'state') {
          return !!geo?.stateId && !geo?.districtId && !geo?.blockId;
      }

      return userType === 'national';
  }

  getRoleNameWithBracket(role: string): string {
      //  this.loadSubRolesFromPermissionAPI();
      const match = role.match(/^(.+?)\((.+?)\)$/);
      const roleName = match ? match[1] : role;
      const geoId = match ? match[2] : '';
      const displayName = this.findRoleConfig(roleName)?.name || roleName;
      return `${displayName} (${geoId})`;
  }


  getSelectedRoleDisplayName(): string {

      const selectedRole =
    this.userDetails?.selectedRoleWithGeo ||
    this.userDetails?.role?.[0];

      if (!selectedRole) {
          return '';
      }

      if (selectedRole.includes('(')) {
          return this.getRoleNameWithBracket(selectedRole);
      }

      const match =
    selectedRole.match(/^(.+?)\((.+?)\)$/);

      const roleName =
    match ? match[1] : selectedRole;

      // ✅ proper display name
      return (
          this.findRoleConfig(roleName)?.name ||

    roleName
        .replace(/-/g, ' ')
        .replace(/\b\w/g, (c: string) => c.toUpperCase())
      );
  }


  async signOutUser() {
      this.keycloakService.logout(window.location.origin).then((res: any) => {
          this.gs.clearSensitiveUserContext();
          this.localStorageService.clearStorage();
          this.localStorageService.clearSessionStorage();
      });



      // await this.keycloakService.login({
      //     redirectUri: window.location.origin
      // });
  }
  loadSubRolesFromPermissionAPI() {

      const userId = this.userDetails?.sub;

      if (!userId) {
          return;
      }

      // ✅ check flag
      // if (!this.userDetails?.hasBlockCadreIB) {
      //   return;
      // }

      this.gs.getPermission(userId).subscribe((response: any[]) => {

          const finalSubRoles: string[] = [];

          const blockId = this.userDetails?.blockId;

          // ✅ find ONLY CLF Bookkeeper
          const clfRole = response.find((item: string) => {
              const [category, role] = item.split(':').map(x => x.trim().toLowerCase());

              return (
                  category.includes('institutional') &&
          role === 'clf bookkeeper'
              );
          });

          if (clfRole) {
              const roleName = clfRole.split(':')[1].trim();

              finalSubRoles.push(`${roleName} (${blockId})`);
          }

          // ✅ merge roles
          this.rolesGroup = [
              ...(this.userDetails?.role || []),
              ...finalSubRoles
          ];
      });
  }
}

